var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"finance_tab"},[_c('table',[_c('th')])])
}]

export { render, staticRenderFns }